import { render } from "./Dashboard.vue?vue&type=template&id=669b4b22&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=669b4b22&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=669b4b22&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669b4b22"]])

export default __exports__